<template>
  <section class="num-opponents-selector">
    <button
      class="btn btn-default"
      v-bind:disabled="numOpponents === 1 || !authorized"
      v-on:click="$emit('removeOpponent')"
    >
      -
    </button>
    <span>{{ numOpponents }}</span>
    <button
      class="btn btn-default"
      v-bind:disabled="numOpponents === 9 || !authorized"
      v-on:click="$emit('addOpponent')"
    >
      +
    </button>
  </section>
</template>

<script>
export default {
  name: 'num-opponents-selector',
  props: ['numOpponents', 'authorized'],
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/guided-analyses/num-opponents-selector.vue